'use client';

import React from 'react'

import CareerOverviewHeroSection from './components/CareerOverviewHeroSection'
import CareerWhyChooseUs from './components/CareerWhyChooseUs'
import JoinOurTeam from './components/JoinOurTeam'
import StepInto from './components/StepInto'
import JoinBenzatine from '../our-culture/components/JoinBenzatine'
import LifeBenzatineInfotech from '../components/LifeBenzatineInfotech'
import { ContactUsForm } from '@/components'

function CareerOverviewPage() {
   return (
      <>
         <CareerOverviewHeroSection />
         <CareerWhyChooseUs />
         <JoinOurTeam />
         <StepInto />
         <JoinBenzatine />
         <LifeBenzatineInfotech />
         <ContactUsForm />
      </>
   )
}

export default CareerOverviewPage
